import moment from 'moment';
import { getOfficialName, getFirstName, getLastName } from '../utils';
import Quartiles from './quartiles';
import Inventory from './inventory';
import app from '../../app';


export const id = (state) => state.user.patient.patientId
  ? state.user.patient.patientId.toString() : '';

export const officialName = (state) => getOfficialName(state.user.patient.name);

export const firstName = (state, getters) => getFirstName(getters.officialName);

export const lastName = (state, getters) => getLastName(getters.officialName);

export const fullOfficialName = (state, getters) => {
  const { firstName, lastName } = getters;
  return `${firstName} ${lastName}`;
}

export const initials = (state, getters) => `${getters.firstName.substr(0, 1)}. ${getters.lastName.substr(0, 1)}.`;

export const gender = (state) => state.user.patient.gender;

export const yearOfBirth = (state) => state.user.patient.birthdate.substr(0, 4);

export const studyId = (state) => state.user.subjectId;

export const enrollmentDate = (state) => state.user.enrollmentDate || '';

export const visit1Date = (state) => state.user.visit1Date || '';

export const importDate = (state) => state.user.patient.createdAt || '';

export const isBlocked = (state) => state.user.blocked;

export const startDate = (state) => state.user.enrollmentDate
  ? moment(state.user.enrollmentDate).format('DD-MM-YYYY') : '';

export const bloodPressure = (state) => {
  const { bloodPressure } = state;
  if (!bloodPressure || !bloodPressure.component) return '';

  const systolicComponent = bloodPressure.component[0];
  const diastolicComponent = bloodPressure.component[1];

  if (!systolicComponent || !diastolicComponent) return '';

  const systolicValue = systolicComponent.valueQuantity.value;
  const diastolicValue = diastolicComponent.valueQuantity.value;

  return `${systolicValue}/${diastolicValue}`;
}

export const bloodPressureUnit = (state) => {
  const { bloodPressure } = state;
  if (!bloodPressure || !bloodPressure.component) return '';

  const systolicComponent = bloodPressure.component[0];

  if (!systolicComponent) return '';

  const systolicUnit = systolicComponent.valueQuantity.unit;

  return systolicUnit || '';
}

export const weight = (state) => {
  if (!state.weight || !state.weight.valueQuantity) return '';

  const { value } = state.weight.valueQuantity;
  return value || '';
}

export const weightUnit = (state) => {
  if (!state.weight || !state.weight.valueQuantity) return '';

  const { unit } = state.weight.valueQuantity;
  return unit || '';
}

export const cholesterolLDL = (state) => {
  if (!state.LDL || !state.LDL.valueQuantity) return '';

  const { value } = state.LDL.valueQuantity;
  return value || '';
}

export const cholesterolLDLInPreferredUnit = (state) => {
  if (!state.LDLInPreferredUnit || !state.LDLInPreferredUnit.valueQuantity) {
    return '';
  }

  const { value } = state.LDLInPreferredUnit.valueQuantity;
  return value || '';
}

export const cholesterolLDLPreferredUnit = (state) => {
  return state?.LDLInPreferredUnit.valueQuantity.unit ? state.LDLInPreferredUnit.valueQuantity.unit : 'mg/dL';
}

export const cholesterolLDLPreferredUnitLabel = (state, getters) => {
  return app.translationManager.translate(`units.${getters.cholesterolLDLPreferredUnit}`, {catalog : 'app_mobile'});
}

export const glucose = (state) => {
  if (!state.HbA1c || !state.HbA1c.valueQuantity) return '';

  const { value } = state.HbA1c.valueQuantity;
  return value || '';
}

export const glucoseInPreferredUnit = (state) => {
  if (!state.HbA1cInPreferredUnit || !state.HbA1cInPreferredUnit.valueQuantity) {
    return '';
  }

  const { value } = state.HbA1cInPreferredUnit.valueQuantity;
  return value || '';
}

export const glucosePreferredUnit = (state) => {
  return state?.HbA1cInPreferredUnit.valueQuantity.unit ? state.HbA1cInPreferredUnit.valueQuantity.unit : '%';
}

export const glucosePreferredUnitLabel = (state, getters) => {
  return app.translationManager.translate(`units.${getters.glucosePreferredUnit}`, {catalog : 'app_mobile'});
}

export const age = (state) => {
  if (!state.user.patient.birthdate) return '';

  const birthDate = moment(state.user.patient.birthdate, 'YYYY-MM-DD');
  const today = moment();

  return today.diff(birthDate, 'years');
}

export const email = (state) => {
  const priority = ['home', 'work'];
  const emailRecords = state.user.patient.telecom
    .filter((item) => item.system === 'email')
    .sort((a, b) => priority.indexOf(a.use) - priority.indexOf(b.use));

  return emailRecords.length ? emailRecords[0].value : '';
}

export const phone = (state) => {
  const priority = ['home', 'work'];
  const phoneRecords = state.user.patient.telecom
    .filter((item) => item.system === 'phone')
    .sort((a, b) => priority.indexOf(a.use) - priority.indexOf(b.use));

  return phoneRecords.length ? phoneRecords[0].value : '';
}

export const length = (state) => state.length.valueQuantity.value;

export const BMI = (state) => state.BMI.valueQuantity.value;

export const BMIDate = (state) => state.BMI.effectiveDateTime;

export const SDMEncounters = (state) => state.SDMEncounters || [];

export const getCurrentInProgressSDMEncounter = (state, getters) => {
  const encounters= getters.SDMEncounters

  for (let i=0; i<encounters.length; i++){
    if (encounters[i].status === 'inprogress'){
      return encounters[i]
    }
  }

  return null
}

export const getEncounter = (state, getters) => (version) => {
  const encounters= getters.SDMEncounters

  version = Number(version)

  for (let i=0; i<encounters.length; i++){
    if (encounters[i].version === version){
      return encounters[i]
    }
  }

  return null
}

export const completedSDMEncounters = (state) => {
  const { SDMEncounters } = state;
  if (!SDMEncounters) return [];

  return SDMEncounters.filter((item) => item.status === 'done');
}

export const completedOrSkippedSDMEncounters = (state) => {
  const { SDMEncounters } = state;
  if (!SDMEncounters) return [];

  return SDMEncounters.filter((item) => item.status === 'done' || item.status === 'skipped');
}

export const lastCompletedSDMEncounter = (state, getters) => {
  return getters.completedSDMEncounters
    .sort((a, b) => new Date(b.encounterDate).getTime() - new Date(a.encounterDate).getTime())[0] || {};
}

export const lastCompletedOrSkippedSDMEncounter = (state, getters) => {
  return getters.completedOrSkippedSDMEncounters
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0] || {};
}

export const lastCompletedSDMEncounterDate = (state, getters) => {
  if (getters.lastCompletedSDMEncounter !== null) {
    return moment(getters.lastCompletedSDMEncounter.encounterDate);
  } else if (state.user.visit1Date) {
    return moment(state.user.visit1Date)
  }

  return moment(state.user.enrollmentDate)
}

export const lastCompletedOrSkippedSDMEncounterDate = (state, getters) => {
  if (getters.lastCompletedOrSkippedSDMEncounter !== null) {
    return moment(getters.lastCompletedOrSkippedSDMEncounter.date);
  } else if (state.user.visit1Date) {
    return moment(state.user.visit1Date)
  }

  return moment(state.user.enrollmentDate)
}

export const currentVersion = (state, getters) => {
  const lastVisit = getters.getEncounter(7);
  return state.targetVersion ? state.targetVersion : lastVisit ? 7 : 1;
}

export const lastVersion = (state, getters) => getters
  .lastCompletedSDMEncounter.version || 0;

export const knowledgeLevel = (state) => state.user.knowledgeLevel || {};

export const knowledgeLevelName = (state, getters) => getters
  .knowledgeLevel.name || '';

export const knowledgeLevelKey = (state, getters) => getters
  .knowledgeLevel.key || '';

export const settings = (state) => state.patientSettings || [];

export const quartiles = (state, getters) => new Quartiles(getters.settings);

export const outcomeComponents = (state) => new Inventory(state.outcomeComponents);

export const outcomeGoals = (state) => new Inventory(state.outcomeGoals);

export const behaviourComponents = (state) => new Inventory(state.behaviourComponents);

export const behaviourGoals = (state) => new Inventory(state.behaviourGoals);

export const searchText = (state, getters) => {
  const birthDate = moment(state.user.patient.birthdate).format('YYYY');
  return `${getters.studyId} (${birthDate})`;
}

export const isResetRequired = (state) => state.isResetRequired;

export const dailySportsActivityWeekStartDate = (state) => state.dailySportsActivityWeekStartDate;

export const targetWeightValue = (state) => state.user.patient.targetWeightValue;

export const targetWeightUnit = (state) => state.user.patient.targetWeightUnit;

export const distanceWalked = (state) => {
  if (!state.lastCompletedSixMinuteWalkingTest || !state.lastCompletedSixMinuteWalkingTest.distanceWalked) {
    return '';
  }

  return state.lastCompletedSixMinuteWalkingTest.distanceWalked || '';
};

export const heartRate = (state) => {
  if (!state.heartRate || !state.heartRate.valueQuantity) return '';

  const { value } = state.heartRate.valueQuantity;
  return value || '';
}

export const getBehaviourComponent = (state, getters) => (behaviourComponentKey) => {
  if (state.behaviourComponents){
    return state.behaviourComponents.filter((behaviourComponent) => behaviourComponent.key === behaviourComponentKey)?.[0];
  } else {
    return null;
  }
}

export const unsavedChanges = (state) => (screen, full) => {
  if (screen) {
    const unsaved = state.unsavedChangesMultiple.filter(item => item.screen === screen);
    return !full ? unsaved.some(item => item.unsavedChanges) : unsaved
  } else {
    return state.unsavedChanges;
  }
}

export const anyUnsavedChanges = (state) => {
  if (state.unsavedChanges || state.unsavedChangesMultiple.length) {
    return true
  } else {
    return false
  }
}

export const hadSecondVascularEventOnStatins = (state) => state.hadSecondVascularEventOnStatins;
